(() => {
  const root = document.querySelector('[data-inspiration]');
  if (!root) return;

  const tabs = root.querySelectorAll('[role="tab"]');
  const panels = root.querySelectorAll('[role="tabpanel"]');

  function activateTab(tabName) {
    tabs.forEach(t => {
      const active = t.dataset.tab === tabName;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    panels.forEach(p => {
      const active = p.id === 'panel-' + tabName;
      p.classList.toggle('is-active', active);
      p.hidden = !active;
    });
  }
  tabs.forEach(t => t.addEventListener('click', () => activateTab(t.dataset.tab)));

  // Open the matching tab when arriving via a hash deep-link (e.g. from the homepage).
  function activateFromHash() {
    const hash = (location.hash || '').replace('#', '').toLowerCase();
    if (!hash) return;
    const tabName = (hash === 'community' || hash === 'ugc') ? 'ugc'
      : (hash === 'lookbook') ? 'lookbook'
      : (hash === 'kits') ? 'kits'
      : null;
    if (tabName) activateTab(tabName);
  }
  activateFromHash();
  window.addEventListener('hashchange', activateFromHash);

  const sectionId = root.dataset.sectionId;

  panels.forEach(panel => {
    const search = panel.querySelector('[data-search]');
    const empty = panel.querySelector('[data-empty]');
    const grid = panel.querySelector('.inspiration__grid');

    const getFilters = () => panel.querySelectorAll('[data-filter]');
    const getCards = () => panel.querySelectorAll('.inspiration__card');
    const getLoadMore = () => panel.querySelector('[data-load-more]');

    let loadingMore = false;

    function apply() {
      const filterValues = {};
      getFilters().forEach(f => {
        if (f.value) filterValues[f.dataset.filter] = f.value.toLowerCase();
      });
      const q = (search?.value || '').trim().toLowerCase();

      let visibleCount = 0;
      getCards().forEach(card => {
        let visible = true;

        for (const [key, val] of Object.entries(filterValues)) {
          const cardVal = (card.dataset[toCamel(key)] || '').toLowerCase();
          // Cards may carry several values for one facet (e.g. a kit using
          // multiple yarns), joined by "~~". Single-value facets are just a
          // one-element list, so this stays an exact match for them.
          if (!cardVal.split('~~').includes(val)) { visible = false; break; }
        }

        if (visible && q) {
          const haystack = (card.dataset.searchText || '').toLowerCase();
          if (!haystack.includes(q)) visible = false;
        }

        card.hidden = !visible;
        if (visible) visibleCount++;
      });

      if (empty) empty.hidden = visibleCount > 0;
    }

    // Build the option lists for any [data-filter-auto] dropdown from the
    // values on the currently-loaded cards, so they stay complete as more
    // pages are appended. Multi-value facets store values "~~"-joined.
    function populateAutoFilters() {
      panel.querySelectorAll('[data-filter-auto]').forEach(sel => {
        const camel = toCamel(sel.dataset.filter);
        const values = new Set();
        getCards().forEach(card => {
          (card.dataset[camel] || '').split('~~').forEach(v => {
            v = v.trim();
            if (v) values.add(v);
          });
        });
        const keep = sel.value;
        const defaultOpt = sel.options[0];
        sel.replaceChildren(defaultOpt);
        [...values].sort((a, b) => a.localeCompare(b, 'de', { sensitivity: 'base' }))
          .forEach(v => {
            const o = document.createElement('option');
            o.value = v;
            o.textContent = v;
            sel.appendChild(o);
          });
        if ([...sel.options].some(o => o.value === keep)) sel.value = keep;
      });
    }

    // ── Load more (Section Rendering API) ───────────────────────────────────
    // Fetch the next paginated page of this section, lift its cards into the
    // current grid, and carry the button's next-url forward. Mirrors the
    // fetch / parse / querySelector swap in pdp-pairings.js.
    async function loadNextPage() {
      const btn = getLoadMore();
      if (!btn || loadingMore || !sectionId || !grid) return false;
      const nextUrl = btn.dataset.nextUrl;
      if (!nextUrl) return false;

      loadingMore = true;
      const label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Lädt …';
      try {
        const sep = nextUrl.includes('?') ? '&' : '?';
        const res = await fetch(`${nextUrl}${sep}section_id=${encodeURIComponent(sectionId)}`,
          { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('fetch failed');
        const tmp = document.createElement('div');
        tmp.innerHTML = await res.text();

        const freshGrid = tmp.querySelector(`[data-grid="${grid.dataset.grid}"]`);
        if (freshGrid) {
          freshGrid.querySelectorAll('.inspiration__card').forEach(c => grid.appendChild(c));
        }
        const freshBtn = tmp.querySelector('[data-load-more]');
        if (freshBtn && freshBtn.dataset.nextUrl) {
          btn.dataset.nextUrl = freshBtn.dataset.nextUrl;
          btn.disabled = false;
          btn.textContent = label;
        } else {
          btn.remove();
        }
        populateAutoFilters();
        apply();
        return true;
      } catch (e) {
        btn.disabled = false;
        btn.textContent = label;
        return false;
      } finally {
        loadingMore = false;
      }
    }

    async function loadAll() {
      let guard = 0;
      while (getLoadMore() && guard < 100) {
        if (!(await loadNextPage())) break;
        guard++;
      }
    }

    // A filter/search should cover the whole catalogue, so pull in any
    // remaining pages first, then filter the full set.
    async function onFilterChange() {
      if (getLoadMore()) {
        grid?.setAttribute('data-loading', 'true');
        await loadAll();
        grid?.removeAttribute('data-loading');
      }
      apply();
    }

    getFilters().forEach(f => f.addEventListener('change', onFilterChange));
    search?.addEventListener('input', debounce(onFilterChange, 200));
    panel.addEventListener('click', e => {
      if (e.target.closest('[data-load-more]')) loadNextPage();
    });

    // As soon as the user engages the filter area, quietly pull in the rest so
    // the dropdowns are complete and a pick filters the whole catalogue.
    panel.querySelector('.inspiration__filters')
      ?.addEventListener('focusin', () => { if (getLoadMore()) loadAll(); });

    populateAutoFilters();
    apply();
  });

  function toCamel(s) {
    return s.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
  }

  function debounce(fn, ms) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  }
})();
